import { render, staticRenderFns } from "./PlatformInfoCard.vue?vue&type=template&id=678a856e"
import script from "./PlatformInfoCard.vue?vue&type=script&lang=js"
export * from "./PlatformInfoCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports